import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import AdvancedTable from '../../Components/AdvancedTable'
import ProductActions from '../../Redux/ProductRedux'
import FormatMoney from '../../Utils/FormatMoney'

class ProductVariantStocks extends React.Component {
  constructor (props) {
    super(props)
    this.variant_id = this.props.detail.id
    this.formLines = [
      { field: 'price', label: 'Price' },
      { field: 'qty', label: 'Quantity' }
    ]
    this.state = {
      detail: {},
      form: {
        price: '',
        qty: ''
      },
      showModal: null
    }
  }

  componentDidMount = () => {
    this._fetchProductVariantItem()
  }

  _fetchProductVariantItem = () => {
    this.props.getProductVariantItem({ variant_id: this.variant_id })
  }

  _handleInputChange = (event, field) => {
    let value = event.target.value
    let form = { ...this.state.form }
    form[field] = value
    this.setState({ form })
  }

  _onSubmit = (event) => {
    if (event) { event.preventDefault() }
    let form = { ...this.state.form }
    let data = {
      variant_id: this.variant_id,
      form
    }
    this.props.postProductVariantItem(data)
    setTimeout(() => {
      this._resetForm()
    }, 300)
  }

  _resetForm = () => {
    let form = { ...this.state.form }
    form.qty = ''
    form.price = ''
    this.setState({ form })
  }

  _onDelete = (id) => {
    let data = {
      productvariantitemuuid: id
    }
    this.props.deleteProductVariantItem(data)
    setTimeout(() => {
      this._toggleModal(null)
    }, 300)
  }

  _selectItem = (item, modalID) => {
    this.setState({ detail: item })
    this._toggleModal(modalID)
  }

  _toggleModal = (modalID) => {
    this.setState({ showModal: modalID })
  }

  _renderHeader = (data, title) => {
    return (
      <React.Fragment>
        <header className='title-block'>
          <h1 className='title'>
            { title }
            {
              (data.fetching || data.processing) &&
              <div className='badge badge-info ml-2'>
                {
                  data.fetching
                    ? 'Loading ...'
                    : data.processing
                      ? 'Processing ...'
                      : ''
                }
              </div>
            }
          </h1>
        </header>
        { data.err && <div className='alert alert-danger'>{data.err}</div> }
      </React.Fragment>
    )
  }

  _renderForm = (formLines) => {
    return (
      <form className='mb-3' onSubmit={(event) => this._onSubmit(event)}>
        { formLines.map((lines, i) => this._renderFormLine(i, lines.field, lines.label)) }
        <div className='row'>
          <div className='col-9 text-right'>
            <button className='btn btn-primary' type='submit'><i className='fa fa-plus' /> Add Stock</button>
          </div>
        </div>
      </form>
    )
  }

  _renderFormLine = (i, field, label) => {
    return (
      <div key={i} className='form-group'>
        <div className='row'>
          <div className='col-3'>
            <label className='control-label'>{label}</label>
          </div>
          <div className='col-6'>
            <input
              value={this.state.form[field]}
              type='number'
              min={0}
              required
              placeholder={`Insert ${label} ...`}
              className='form-control'
              onChange={(event) => this._handleInputChange(event, field)}
            />
          </div>
        </div>
      </div>
    )
  }

  _renderTable = (product) => {
    return (
      <AdvancedTable
        colSpan={3}
        header={[
          { field: 'Quantity' },
          { field: 'Price' },
          { field: 'Delete' }
        ]}
        body={
          product.variant_item &&
          product.variant_item.length > 0 &&
          product.variant_item.map((item, i) => ([
            { field: item.qty },
            { field: FormatMoney(item.price) },
            {
              field: <button className='btn btn-danger' type='button' onClick={() => this._selectItem(item, 'delete-product-variant-stocks')}>
                <i className='fa fa-trash' />
              </button>
            }
          ]))
        }
      />
    )
  }

  render () {
    const { product } = this.props
    return (
      <section className='section' style={{ width: '60vw' }}>
        { this._renderHeader(product, 'Manage Dynamic Price Stock') }
        { this._renderForm(this.formLines) }
        { this._renderTable(product) }
        <React.Fragment>
          <Modal
            onClose={() => this._toggleModal(null)}
            classNames={{ modal: 'modal-large' }}
            center
            open={this.state.showModal === 'delete-product-variant-stocks'}
          >
            <section className='section' style={{ width: '50vw' }}>
              <header className='title-block'>
                <h1 className='title'>Delete Dynamic Price Stock</h1>
              </header>
              <div>
                <p className='text-center'>Quantity Left: <strong>{this.state.detail.qty}</strong></p>
                <p className='text-center'>Price: <strong>{this.state.detail.price}</strong></p>
              </div>
              <div className='row'>
                <div className='col-12 text-right'>
                  <button
                    className='btn btn-danger'
                    onClick={() => this._onDelete(this.state.detail.id)}
                  >
                    <i className='fa fa-trash' /> Delete
                  </button>
                </div>
              </div>
            </section>
          </Modal>
        </React.Fragment>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  product: state.product
})

const dispatchToProps = (dispatch) => ({
  getProductVariant: (data) => dispatch(ProductActions.getProductVariantRequest(data)),
  postProductVariant: (data) => dispatch(ProductActions.postProductVariantRequest(data)),
  putProductVariant: (data) => dispatch(ProductActions.putProductVariantRequest(data)),
  deleteProductVariant: (data) => dispatch(ProductActions.deleteProductVariantRequest(data)),
  getProductVariantItem: (data) => dispatch(ProductActions.getProductVariantItemRequest(data)),
  postProductVariantItem: (data) => dispatch(ProductActions.postProductVariantItemRequest(data)),
  deleteProductVariantItem: (data) => dispatch(ProductActions.deleteProductVariantItemRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ProductVariantStocks)



// WEBPACK FOOTER //
// ./src/Containers/Product/ProductVariantStocks.js